import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useMemo } from 'react';
import classnames from 'classnames';
import range from "../util/range";

var Placeholder = function Placeholder(_ref) {
  var _classnames;

  var className = _ref.className,
      color = _ref.color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 100 : _ref$width,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 0.75 * width : _ref$minWidth,
      _ref$words = _ref.words,
      words = _ref$words === void 0 ? 1 : _ref$words,
      size = _ref.size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'glow' : _ref$type,
      props = _objectWithoutProperties(_ref, ["className", "color", "width", "minWidth", "words", "size", "type"]);

  var containerClasses = classnames(className, (_classnames = {}, _defineProperty(_classnames, "placeholder-".concat(type), type), _defineProperty(_classnames, "text-".concat(color), color), _classnames));
  var classes = classnames('placeholder', 'rounded-pill', _defineProperty({}, "placeholder-".concat(size), size));
  var widths = useMemo(function () {
    var lineWidth = minWidth + Math.random() * (width - minWidth);
    var maxWords = Math.ceil(Math.random() * words);
    var numbers = range(maxWords).map(function () {
      return Math.max(Math.random(), 0.2);
    });
    var sum = numbers.reduce(function (total, n) {
      return total + n;
    }, 0);
    return numbers.map(function (n) {
      return n / sum * lineWidth;
    });
  }, [minWidth, width, words]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: "jsx-1111815887" + " " + (props && props.className != null && props.className || containerClasses || "")
  }), widths.map(function (wordWidth, i) {
    return /*#__PURE__*/React.createElement("span", {
      // eslint-disable-next-line react/no-array-index-key
      key: i,
      style: {
        width: "calc(".concat(wordWidth.toFixed(), "% - .5rem)")
      },
      className: "jsx-1111815887" + " " + (classes || "")
    });
  })), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1111815887"
  }, ".placeholder.jsx-1111815887{background-color:currentColor;cursor:wait;display:inline-block;margin-right:0.25rem;min-height:1em;opacity:0.5;vertical-align:middle;}.placeholder-xs.jsx-1111815887{min-height:0.6em;}.placeholder-sm.jsx-1111815887{min-height:0.8em;}.placeholder-lg.jsx-1111815887{min-height:1.2em;}.placeholder-glow.jsx-1111815887 .placeholder.jsx-1111815887{-webkit-animation:placeholder-glow-jsx-1111815887 2s ease-in-out infinite;animation:placeholder-glow-jsx-1111815887 2s ease-in-out infinite;}@-webkit-keyframes placeholder-glow-jsx-1111815887{50%{opacity:0.2;}}@keyframes placeholder-glow-jsx-1111815887{50%{opacity:0.2;}}.placeholder-wave.jsx-1111815887{-webkit-mask-image:linear-gradient( 130deg, #000 55%, rgba(0,0,0,0.65) 75%, #000 95% );-webkit-mask-size:200% 100%;-webkit-mask-image:linear-gradient( 130deg, currentcolor 55%, rgba(0,0,0,0.65) 75%, currentcolor 95% );mask-image:linear-gradient( 130deg, currentcolor 55%, rgba(0,0,0,0.65) 75%, currentcolor 95% );-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:placeholder-wave-jsx-1111815887 2s linear infinite;animation:placeholder-wave-jsx-1111815887 2s linear infinite;}@-webkit-keyframes placeholder-wave-jsx-1111815887{100%{-webkit-mask-position:-200% 0%;-webkit-mask-position:-200% 0%;mask-position:-200% 0%;}}@keyframes placeholder-wave-jsx-1111815887{100%{-webkit-mask-position:-200% 0%;-webkit-mask-position:-200% 0%;mask-position:-200% 0%;}}"));
};

Placeholder.displayName = 'Placeholder';
export default Placeholder;